<template>
  <base-floating-card @close="close">
    <div id="make-payment-wrapper">
      <div id="invoice-details">
        <div
          class="invoice-detail"
          v-for="(detail, index) in invoiceDetails"
          :key="index"
        >
          <p>{{ detail.title }}</p>
          <h3>
            {{ detail.amount }}
          </h3>
        </div>
      </div>
      <div id="action-body">
        <component
          :is="activeComponent"
          class="make-payment-step"
          :event="event"
          :paymentIntent="paymentIntent"
          :stripePk="stripeAPIToken"
          @successful-payment="recordSuccessfulPayment"
          @payment-intent-created="setPaymentIntent"
          @navigate-backwards="navigate"
          @navigate-forward="navigate"
          @close="close"
        />
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../../BaseFloatingCard.vue";
// import Backdrop from "../../SharedComponentsUI/Backdrop.vue";
import ChooseDigitalPaymentAmount from "./ChooseDigitalPaymentAmount.vue";
import PhysicalPaymentInstructions from "./PhysicalPaymentInstructions.vue";
import OtherPaymentInstructions from "./OtherPaymentInstructions.vue";
import ChoosePaymentType from "./ChoosePaymentType.vue";
// import StripeEnterCardDetails from "./Stripe/StripeEnterCardDetails.vue";
import ManuallyRecordPayment from "./ManuallyRecordPayment.vue";
import SuccessfulPaymentNotification from "./SuccessfulPaymentNotification.vue";
import {
  balanceOutstanding,
  total,
  formatPrice,
  finalPaymentDueDate,
  formatDate,
} from "../../../../../Helpers/invoice.js";
import { loadStripe } from "@stripe/stripe-js";

export default {
  data() {
    return {
      method: "stripe",
      activeComponent: "choosePaymentType",
      stripe: null,
      payeeAccount: null,
      stripeAPIToken:
        "pk_live_51KB2fZJb4IVAatoGPTcDxwy6Ktx8pcAYFBeYRE6JEUq4fKiyxXpiWPWuCeA5XNzmqNFUi9DwWiowngI594BjiXrY00BeFT0rTK",
      // "pk_test_51KB2fZJb4IVAatoGYdJekSis2i0uQilzUHqTvfE3P6x7OJkDhdahSWKMzCocECTUslikYgWZTAvr1npNMGUNaWm800To81qBha",
      step: 1,
      manualPayment: {
        name: undefined,
        amount: undefined,
      },
      paymentNameError: false,
      paymentAmountError: false,
      paymentIntent: undefined,
      clientSecret: undefined,
    };
  },
  computed: {
    userRole() {
      return this.$store.getters.userRole;
    },
    invoiceDetails() {
      return [
        {
          title: "Total",
          amount: formatPrice(total(this.event)),
        },
        {
          title: "Payments Made",
          amount: formatPrice(
            total(this.event) - balanceOutstanding(this.event)
          ),
        },
        {
          title: "Outstanding",
          amount: formatPrice(balanceOutstanding(this.event)),
        },
      ];
    },
    finalPaymentDueDate() {
      return formatDate(
        finalPaymentDueDate(
          this.event,
          this.$store.state.businessSettings.payments.finalPayment
        )
      );
    },
  },
  methods: {
    balanceOutstanding,
    total,
    formatPrice,
    navigate(component) {
      this.activeComponent = component;
    },

    setPaymentIntent(intent) {
      this.paymentIntent = intent.data;
      this.clientSecret = intent.data.client_secret;
      // this.navigate("StripeEnterCardDetails");
    },

    async recordSuccessfulPayment(intent) {
      this.paymentIntent = intent;
      if (this.activeComponent === "manually-record-payment") {
        this.$emit("applyManualPayment", intent);
      }
      let parameters = {
        variable: "invoice_payments",
        value: {
          name: intent.name,
          amount: intent.amount,
        },
        operation: "add",
        api_version: this.event.api_version,
        eventKey: {
          userId: this.event.userId,
          tenantId: this.event.tenantId,
        },
      };
      this.$store.commit("editEvent", parameters);
      this.navigate("successfulPaymentNotification");
    },
    close() {
      this.$emit("close");
    },
  },

  async created() {
    this.payeeAccount = await this.$store.dispatch("stripeCheckAccount");
    this.stripe = await loadStripe(this.stripeAPIToken, {
      stripeAccount: this.payeeAccount.id,
    });
  },
  components: {
    BaseFloatingCard,
    // StripeEnterCardDetails,
    SuccessfulPaymentNotification,
    PhysicalPaymentInstructions,
    ChoosePaymentType,
    ManuallyRecordPayment,
    OtherPaymentInstructions,
    ChooseDigitalPaymentAmount,
    // Backdrop,
  },
  emits: ["apply-manual-payment", "close"],
  props: ["event"],
};
</script>
<style scoped>
#make-payment-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  border-radius: 10px;
  padding: 20px 0;
}

#invoice-details {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  margin: auto;
  /* height: 60px; */
  width: calc(100% - 40px);
}

.invoice-detail {
  border-bottom: 1px solid var(--contrastColor);
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.invoice-detail > p {
  margin: 0;
}

.invoice-detail > h3 {
  margin: 3px;
  font-size: 10pt;
}

.invoice-detail:last-child {
  border: none;
}

#action-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: scroll;
  height: auto;
  width: 100%;
}

.make-payment-step {
  width: 100%;
  max-width: 90%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.due-date-reminder {
  right: 13px;
  bottom: 3px;
  height: 10px;
}
@media screen and (min-width: 800px) {
  #make-payment-wrapper {
    width: 600px;
    min-width: 50%;
    height: 400px;
    padding: 20px;
    flex-direction: row;
    align-items: center;
  }

  #invoice-details {
    flex-direction: column;
    height: 100%;
    width: 130px;
  }

  .invoice-detail {
    border-bottom: 1px solid var(--contrastColor);
    border-right: 0;
  }

  .invoice-detail > h3 {
    font-size: 18pt;
  }

  #action-body {
    justify-content: center;
  }

  .make-payment-step {
    /* min-height: 300px; */
    /* height: 100%; */
    width: 100%;
    max-width: 90%;
    box-sizing: border-box;
  }

  .due-date-reminder {
    position: absolute;
    right: 13px;
    bottom: 3px;
  }
}
</style>
